var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelpTipIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 52,
  viewBox: "0 0 52 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.1,
  cx: 25.9274,
  cy: 25.9149,
  r: 25.2225,
  fill: "#79A342"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M34.3647 24.0923V17.8106H18.0322V35.3994H23.0827C23.1456 36.2914 23.3591 37.1332 23.6858 37.9121H18.0322C16.6502 37.9121 15.5195 36.7814 15.5195 35.3994V17.8106C15.5195 16.4286 16.6502 15.2979 18.0322 15.2979H34.3647C35.7467 15.2979 36.8774 16.4286 36.8774 17.8106V21.5796L34.3647 24.0923Z",
  fill: "#79A342"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.3761 27.6644L37.9464 26.2347C37.2129 25.5012 36.0318 25.5012 35.3108 26.2347L27.6216 33.9239V37.9892H31.6869L39.3761 30.3C40.1096 29.5665 40.1096 28.3855 39.3761 27.6644ZM30.8291 36.0622H29.5486V34.7817L34.9502 29.3801L36.2307 30.6606L30.8291 36.0622Z",
  fill: "#79A342"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2879 25.7877H20.9114V27.7054H31.2879V25.7877ZM31.2879 21.9521H20.9114V23.8699H31.2879V21.9521ZM20.9114 31.5409H27.4524V29.6232H20.9114V31.5409Z",
  fill: "#79A342"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelpTipIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/helpTipIcon.1483ea746ee1565778cd15f262076b80.svg";